import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

const MIN_DIALOG_HEIGHT = 600;

export default createUseStyles(({ colors }: Theme) => ({
  '@global': {
    '.config__column--dragover': {
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 2,
        backgroundColor: 'black',
      },
    },
  },
  dialog: {
    minWidth: 800,
    maxWidth: '90vw',
    minHeight: MIN_DIALOG_HEIGHT,
  },
  toolbar: {
    display: 'flex',
    margin: '0 3px',
  },
  configTabs: {
    maxHeight: 500,
  },
  columnsTab: {
    composes: 'column no-wrap',
    paddingLeft: 7,
  },
  columnsWrapper: {
    overflow: 'auto',
  },
  columns: {
    display: 'flex',
    marginBottom: 10,
    alignItems: 'center',
  },
  draggableButton: {
    padding: '0 10px',
    cursor: 'pointer',
  },
  fixedColumns: {
    width: '100%',
    padding: 4,
  },
  tabButton: {
    fontWeight: 'bold',
  },
  designTab: {
    overflowY: 'auto',
  },
  actionsTable: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  actionsThLeft: {
    position: 'sticky',
    top: 0,
    backgroundColor: colors.backgroundGridPrimary,
    zIndex: 1,
  },
  actionsThCenter: {
    width: '1%',
    textAlign: 'center',
    padding: '6px 12px',
    whiteSpace: 'nowrap',
    position: 'sticky',
    top: 0,
    backgroundColor: colors.backgroundGridPrimary,
    zIndex: 1,
  },
  actionsThContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
  },
  actionsRow: {
    userSelect: 'none',
    '&:hover': {
      backgroundColor: colors.backgroundGridPrimary,
    },
  },
  actionsTd: {
    padding: '4px 12px',
    cursor: 'default',
  },
  actionsTdCenter: {
    width: '1%',
    textAlign: 'center',
    padding: '4px 12px',
    whiteSpace: 'nowrap',
  },
  actionsGroupTd: {
    padding: '6px 12px',
    color: colors.typoCaption,
  },
}));
